var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErpImg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3063.83 2881",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#f4f7fa;}.cls-3,.cls-7,.cls-8{fill:#2b69b3;}.cls-4,.cls-65,.cls-73,.cls-83,.cls-84,.cls-93{mix-blend-mode:multiply;}.cls-4{opacity:0.47;fill:url(#linear-gradient);}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:#18174a;}.cls-64,.cls-7{opacity:0.74;}.cls-8{opacity:0.4;}.cls-67,.cls-76,.cls-77,.cls-78,.cls-9{mix-blend-mode:soft-light;}.cls-65,.cls-73,.cls-76,.cls-77,.cls-78,.cls-83,.cls-9{opacity:0.3;}.cls-10,.cls-64,.cls-67{fill:#fff;}.cls-11{fill:url(#linear-gradient-3);}.cls-12{fill:url(#linear-gradient-4);}.cls-13{fill:url(#linear-gradient-5);}.cls-14{fill:url(#linear-gradient-6);}.cls-15{fill:url(#linear-gradient-7);}.cls-16{fill:url(#linear-gradient-8);}.cls-17{fill:url(#linear-gradient-9);}.cls-18{fill:url(#linear-gradient-10);}.cls-19{fill:url(#linear-gradient-11);}.cls-20{fill:url(#linear-gradient-12);}.cls-21{fill:url(#linear-gradient-13);}.cls-22{fill:url(#linear-gradient-14);}.cls-23{fill:url(#linear-gradient-15);}.cls-24{fill:url(#linear-gradient-16);}.cls-25{fill:url(#linear-gradient-17);}.cls-26{fill:url(#linear-gradient-18);}.cls-27{fill:url(#linear-gradient-19);}.cls-28{fill:url(#linear-gradient-20);}.cls-29{fill:url(#linear-gradient-21);}.cls-30{fill:url(#linear-gradient-22);}.cls-31{fill:url(#linear-gradient-23);}.cls-32{fill:url(#linear-gradient-24);}.cls-33{fill:url(#linear-gradient-25);}.cls-34{fill:url(#linear-gradient-26);}.cls-35{fill:url(#linear-gradient-27);}.cls-36{fill:url(#linear-gradient-28);}.cls-37{fill:url(#linear-gradient-29);}.cls-38{fill:url(#linear-gradient-30);}.cls-39{fill:url(#linear-gradient-31);}.cls-40{fill:url(#linear-gradient-32);}.cls-41{fill:url(#linear-gradient-33);}.cls-42{fill:url(#linear-gradient-34);}.cls-43{fill:url(#linear-gradient-35);}.cls-44{fill:url(#linear-gradient-36);}.cls-45{fill:url(#linear-gradient-37);}.cls-46{fill:url(#linear-gradient-38);}.cls-47{fill:url(#linear-gradient-39);}.cls-48{fill:url(#linear-gradient-40);}.cls-49{fill:url(#linear-gradient-41);}.cls-50{fill:url(#linear-gradient-42);}.cls-51{fill:url(#linear-gradient-43);}.cls-52{fill:url(#linear-gradient-44);}.cls-53{fill:url(#linear-gradient-45);}.cls-54{fill:url(#linear-gradient-46);}.cls-55{fill:url(#linear-gradient-47);}.cls-56{fill:url(#linear-gradient-48);}.cls-57{fill:url(#linear-gradient-49);}.cls-58{fill:url(#linear-gradient-50);}.cls-59{fill:url(#linear-gradient-51);}.cls-60{fill:url(#linear-gradient-52);}.cls-61{fill:url(#linear-gradient-53);}.cls-62{opacity:0.69;}.cls-63,.cls-65{fill:#97a6b7;}.cls-66{fill:url(#linear-gradient-54);}.cls-67{opacity:0.5;}.cls-68{fill:#d8dee8;}.cls-69{fill:url(#linear-gradient-55);}.cls-70{fill:url(#linear-gradient-56);}.cls-71{fill:url(#linear-gradient-57);}.cls-72{fill:url(#linear-gradient-58);}.cls-74{fill:url(#linear-gradient-59);}.cls-75{fill:url(#linear-gradient-60);}.cls-76{fill:url(#linear-gradient-61);}.cls-77{fill:url(#linear-gradient-62);}.cls-78{fill:url(#linear-gradient-63);}.cls-79{fill:url(#linear-gradient-64);}.cls-80{fill:url(#linear-gradient-65);}.cls-81{fill:url(#linear-gradient-66);}.cls-82{fill:url(#linear-gradient-67);}.cls-83{fill:url(#linear-gradient-68);}.cls-84,.cls-93{opacity:0.15;}.cls-84{fill:url(#linear-gradient-69);}.cls-85{fill:url(#linear-gradient-70);}.cls-86{fill:url(#linear-gradient-71);}.cls-87{fill:url(#linear-gradient-72);}.cls-88{fill:url(#linear-gradient-73);}.cls-89{fill:url(#linear-gradient-74);}.cls-90{fill:url(#linear-gradient-75);}.cls-91{fill:url(#linear-gradient-76);}.cls-92{fill:url(#linear-gradient-77);}.cls-93{fill:url(#linear-gradient-78);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2109.02,
    y1: 1271.89,
    x2: 2776.37,
    y2: 1271.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa80f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165d7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 2109.02,
    y1: 546.54,
    x2: 2776.37,
    y2: 546.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1283.4,
    y1: 585.46,
    x2: 1301.33,
    y2: 585.46,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1315.26,
    y1: 635.93,
    x2: 1333.14,
    y2: 635.93,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1347.03,
    y1: 604.63,
    x2: 1364.87,
    y2: 604.63,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1378.72,
    y1: 627.23,
    x2: 1396.5,
    y2: 627.23,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1410.32,
    y1: 601.81,
    x2: 1428.06,
    y2: 601.81,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1441.84,
    y1: 615.69,
    x2: 1459.53,
    y2: 615.69,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1473.27,
    y1: 594.67,
    x2: 1490.91,
    y2: 594.67,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1504.62,
    y1: 590.08,
    x2: 1522.22,
    y2: 590.08,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1535.88,
    y1: 618.78,
    x2: 1553.43,
    y2: 618.78,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1567.07,
    y1: 586.08,
    x2: 1584.57,
    y2: 586.08,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1598.17,
    y1: 595.82,
    x2: 1615.62,
    y2: 595.82,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1629.18,
    y1: 634.59,
    x2: 1646.59,
    y2: 634.59,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1660.12,
    y1: 616.34,
    x2: 1677.48,
    y2: 616.34,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1690.97,
    y1: 602.5,
    x2: 1708.29,
    y2: 602.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1721.74,
    y1: 615.89,
    x2: 1739.01,
    y2: 615.89,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1752.43,
    y1: 597.59,
    x2: 1769.66,
    y2: 597.59,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1783.04,
    y1: 592.3,
    x2: 1800.22,
    y2: 592.3,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1283.4,
    y1: 1108.67,
    x2: 1301.33,
    y2: 1108.67,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1315.26,
    y1: 1158.41,
    x2: 1333.14,
    y2: 1158.41,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1347.03,
    y1: 1126.43,
    x2: 1364.87,
    y2: 1126.43,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1378.72,
    y1: 1148.32,
    x2: 1396.5,
    y2: 1148.32,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 1410.32,
    y1: 1122.21,
    x2: 1428.06,
    y2: 1122.21,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1441.84,
    y1: 1135.39,
    x2: 1459.53,
    y2: 1135.39,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1473.27,
    y1: 1113.69,
    x2: 1490.91,
    y2: 1113.69,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1504.62,
    y1: 1108.4,
    x2: 1522.22,
    y2: 1108.4,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1535.88,
    y1: 1136.4,
    x2: 1553.43,
    y2: 1136.4,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1567.07,
    y1: 1103.02,
    x2: 1584.57,
    y2: 1103.02,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1598.17,
    y1: 1112.08,
    x2: 1615.62,
    y2: 1112.08,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1629.18,
    y1: 1150.14,
    x2: 1646.59,
    y2: 1150.14,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 1660.12,
    y1: 1131.22,
    x2: 1677.48,
    y2: 1131.22,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 1690.97,
    y1: 1116.71,
    x2: 1708.29,
    y2: 1116.71,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 1721.74,
    y1: 1129.42,
    x2: 1739.01,
    y2: 1129.42,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1752.43,
    y1: 1110.44,
    x2: 1769.66,
    y2: 1110.44,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 1783.04,
    y1: 1104.47,
    x2: 1800.22,
    y2: 1104.47,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 1283.4,
    y1: 1631.86,
    x2: 1301.33,
    y2: 1631.86,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 1315.26,
    y1: 1680.89,
    x2: 1333.14,
    y2: 1680.89,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 1347.03,
    y1: 1648.21,
    x2: 1364.87,
    y2: 1648.21,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 1378.72,
    y1: 1669.39,
    x2: 1396.5,
    y2: 1669.39,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 1410.32,
    y1: 1642.59,
    x2: 1428.06,
    y2: 1642.59,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 1441.84,
    y1: 1655.06,
    x2: 1459.53,
    y2: 1655.06,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 1473.27,
    y1: 1632.68,
    x2: 1490.91,
    y2: 1632.68,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 1504.62,
    y1: 1626.71,
    x2: 1522.22,
    y2: 1626.71,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 1535.88,
    y1: 1654.01,
    x2: 1553.43,
    y2: 1654.01,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 1567.07,
    y1: 1619.95,
    x2: 1584.57,
    y2: 1619.95,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 1598.17,
    y1: 1628.31,
    x2: 1615.62,
    y2: 1628.31,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 1629.18,
    y1: 1665.68,
    x2: 1646.59,
    y2: 1665.68,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 1660.12,
    y1: 1646.08,
    x2: 1677.48,
    y2: 1646.08,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 1690.97,
    y1: 1630.89,
    x2: 1708.29,
    y2: 1630.89,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 1721.74,
    y1: 1642.92,
    x2: 1739.01,
    y2: 1642.92,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 1752.43,
    y1: 1623.27,
    x2: 1769.66,
    y2: 1623.27,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 1783.04,
    y1: 1616.63,
    x2: 1800.22,
    y2: 1616.63,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 842.08,
    y1: 943.73,
    x2: 1504.23,
    y2: 943.73,
    gradientTransform: "matrix(1, 0, 0.14, 1, -524.72, 13.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 264.51,
    y1: 1502.31,
    x2: 340.28,
    y2: 1502.31,
    gradientTransform: "matrix(1, 0, 0.14, 1, 228.32, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb6fbb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 192.85,
    y1: 1844.7,
    x2: 269.05,
    y2: 1844.7,
    xlinkHref: "#linear-gradient-55"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 341.63,
    y1: 1500.69,
    x2: 428.69,
    y2: 1500.69,
    xlinkHref: "#linear-gradient-55"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 273.44,
    y1: 1840.64,
    x2: 419.89,
    y2: 1840.64,
    xlinkHref: "#linear-gradient-55"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 789.68,
    y1: 2645.66,
    x2: 1305.4,
    y2: 2526.52,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 803.93,
    y1: 2647.18,
    x2: 1308.4,
    y2: 2530.63,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 854.6,
    y1: 2590.95,
    x2: 1243.66,
    y2: 2590.95,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 962.94,
    y1: 2590.73,
    x2: 1139.6,
    y2: 2590.73,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 788.8,
    y1: 2628.28,
    x2: 1215.91,
    y2: 2628.28,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -974.47,
    y1: 3033.1,
    x2: -1039.3,
    y2: 2819.33,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, 985.93, -59.55)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -1030.36,
    y1: 2991.48,
    x2: -1030.36,
    y2: 2648.02,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, 985.93, -59.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f36f56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: -903.9,
    y1: 2991.48,
    x2: -903.9,
    y2: 2648.01,
    xlinkHref: "#linear-gradient-65"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: -880.02,
    y1: 3004.46,
    x2: -944.86,
    y2: 2790.68,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, 985.93, -59.55)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: -1060.06,
    y1: 2250.37,
    x2: -1091.6,
    y2: 2960.06,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, 985.93, -59.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 2809.56,
    y1: 2038.87,
    x2: 3129.84,
    y2: 2697.47,
    gradientTransform: "translate(-1276.62 412.93) rotate(-16.77)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: -983.23,
    y1: 1567.15,
    x2: -1057.2,
    y2: 1686.8,
    xlinkHref: "#linear-gradient-65"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: -707.74,
    y1: 1752.4,
    x2: -856.84,
    y2: 1993.59,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, 985.93, -59.55)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: -694.99,
    y1: 1737.22,
    x2: -823.78,
    y2: 1979.02,
    gradientTransform: "matrix(-0.99, 0.1, 0.1, 0.99, 1038.34, -53.7)",
    xlinkHref: "#linear-gradient-65"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: -722.97,
    y1: 1736.93,
    x2: -687.49,
    y2: 1663.33,
    gradientTransform: "matrix(-0.99, 0.12, 0.12, 0.99, 985.93, -59.55)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: -756.59,
    y1: 1735.21,
    x2: -635,
    y2: 1735.21,
    gradientTransform: "matrix(-0.99, 0.1, 0.1, 0.99, 1038.34, -53.7)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: -761.97,
    y1: 1746.39,
    x2: -640.97,
    y2: 1746.39,
    gradientTransform: "matrix(-0.99, 0.1, 0.1, 0.99, 1038.34, -53.7)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: -767.58,
    y1: 1767.62,
    x2: -699.21,
    y2: 1767.62,
    gradientTransform: "matrix(-0.99, 0.1, 0.1, 0.99, 1038.34, -53.7)",
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: -676.2,
    y1: 1847.72,
    x2: -711.98,
    y2: 1905.59,
    xlinkHref: "#linear-gradient-65"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 1888.79,
    y1: 1727.77,
    x2: 2144.08,
    y2: 1727.77,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1513,71.08C782.61,49.79,150,572.86,54.4,1259.18-50.1,2009.59,525.07,2684.77,1232.79,2792.91c880.28,134.51,1734.1-643.64,1657.44-1487.82C2832.47,669.08,2255.36,92.72,1513,71.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "2048.19 588.12 1693.89 583.85 1511.8 913.89 1693.89 1242.2 2048.19 1234.56 2220.58 910.52 2048.19 588.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "2613.92 951.39 2280.33 953.74 2109.03 1277.15 2280.33 1592.39 2613.92 1578.83 2776.37 1261.24 2613.92 951.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "2613.92 237.62 2280.33 227.22 2109.03 544.08 2280.33 865.86 2613.92 865.05 2776.37 553.67 2613.92 237.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M401.48,234.21V2297.08a45.18,45.18,0,0,0,36.23,44.29l529.86,107L1111.8,1082.52,972,119.85,440.79,189.41A45.18,45.18,0,0,0,401.48,234.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1882.16,155.66l-893-35.76c-35.14-1.41-63.7,24.84-63.7,58.62V2395.91c0,33.78,28.56,59.53,63.7,57.52l893-51.15c32.48-1.86,58.74-29.59,58.74-62V216.6C1940.9,184.25,1914.64,157,1882.16,155.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M986.93,379.1V222.17c0-24,20.25-42.71,45.19-41.78l810.07,30.45c23.23.88,42,20.32,42,43.44v151a40.57,40.57,0,0,1-42,40.7l-810.07-22.21C1007.18,423.13,986.93,403.11,986.93,379.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1071.17,239.58c0,11.07-9.32,19.72-20.82,19.33s-20.86-9.71-20.86-20.8,9.34-19.75,20.86-19.33S1071.17,228.5,1071.17,239.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1137,241.89c0,11-9.27,19.67-20.71,19.28s-20.75-9.68-20.75-20.74,9.3-19.69,20.75-19.28S1137,230.85,1137,241.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1202.38,244.19c0,11-9.22,19.62-20.6,19.23s-20.63-9.65-20.63-20.68,9.24-19.64,20.63-19.23S1202.38,233.18,1202.38,244.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1838.31 408.06 1243.46 390.78 1243.46 225.73 1838.31 247.16 1838.31 408.06"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1301.33 380.84 1283.4 380.31 1283.4 247.04 1301.33 247.67 1301.33 380.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1333.14 381.78 1315.26 381.25 1315.26 248.16 1333.14 248.79 1333.14 381.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1364.87 382.71 1347.03 382.19 1347.03 249.28 1364.87 249.91 1364.87 382.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1396.5 383.65 1378.72 383.12 1378.72 250.39 1396.5 251.02 1396.5 383.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1428.06 384.58 1410.32 384.06 1410.32 251.5 1428.06 252.13 1428.06 384.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1459.53 385.51 1441.84 384.99 1441.84 252.61 1459.53 253.24 1459.53 385.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1490.91 386.44 1473.27 385.92 1473.27 253.72 1490.91 254.34 1490.91 386.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1522.22 387.36 1504.62 386.84 1504.62 254.82 1522.22 255.44 1522.22 387.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1553.43 388.29 1535.88 387.77 1535.88 255.92 1553.43 256.54 1553.43 388.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1584.57 389.21 1567.07 388.69 1567.07 257.02 1584.57 257.63 1584.57 389.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1615.62 390.12 1598.17 389.61 1598.17 258.11 1615.62 258.73 1615.62 390.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1646.59 391.04 1629.18 390.52 1629.18 259.2 1646.59 259.82 1646.59 391.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1677.48 391.95 1660.12 391.44 1660.12 260.29 1677.48 260.9 1677.48 391.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1708.29 392.86 1690.97 392.35 1690.97 261.38 1708.29 261.99 1708.29 392.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1739.02 393.77 1721.74 393.26 1721.74 262.46 1739.02 263.07 1739.02 393.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1769.66 394.68 1752.43 394.17 1752.43 263.54 1769.66 264.14 1769.66 394.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1800.22 395.58 1783.04 395.07 1783.04 264.62 1800.22 265.22 1800.22 395.58"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1301.33 380.84 1283.4 380.31 1283.4 266.91 1301.33 267.52 1301.33 380.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1333.14 381.78 1315.26 381.25 1315.26 367.62 1333.14 368.15 1333.14 381.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1364.87 382.71 1347.03 382.19 1347.03 304.78 1364.87 305.36 1364.87 382.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1396.5 383.65 1378.72 383.12 1378.72 349.74 1396.5 350.29 1396.5 383.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1428.06 384.58 1410.32 384.06 1410.32 298.66 1428.06 299.25 1428.06 384.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1459.53 385.51 1441.84 384.99 1441.84 326.18 1459.53 326.75 1459.53 385.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1490.91 386.44 1473.27 385.92 1473.27 283.92 1490.91 284.52 1490.91 386.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1522.22 387.36 1504.62 386.84 1504.62 274.51 1522.22 275.11 1522.22 387.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1553.43 388.29 1535.88 387.77 1535.88 331.67 1553.43 332.23 1553.43 388.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1584.57 389.21 1567.07 388.69 1567.07 266.03 1584.57 266.64 1584.57 389.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1615.62 390.12 1598.17 389.61 1598.17 285.29 1615.62 285.88 1615.62 390.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1646.59 391.04 1629.18 390.52 1629.18 362.59 1646.59 363.13 1646.59 391.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1677.48 391.95 1660.12 391.44 1660.12 325.87 1677.48 326.43 1677.48 391.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1708.29 392.86 1690.97 392.35 1690.97 297.97 1708.29 298.55 1708.29 392.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1739.02 393.77 1721.74 393.26 1721.74 324.52 1739.02 325.08 1739.02 393.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1769.66 394.68 1752.43 394.17 1752.43 287.68 1769.66 288.27 1769.66 394.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1800.22 395.58 1783.04 395.07 1783.04 276.87 1800.22 277.46 1800.22 395.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M986.93,644.06V487.14c0-24,20.25-42.95,45.19-42.28l810.07,21.5a43.29,43.29,0,0,1,42,43V660.38a41.11,41.11,0,0,1-42,41.16l-810.07-13.26C1007.18,687.87,986.93,668.07,986.93,644.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1071.17,503.61c0,11.07-9.32,19.83-20.82,19.56s-20.86-9.48-20.86-20.57,9.34-19.85,20.86-19.56S1071.17,492.54,1071.17,503.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1137,505.19c0,11.05-9.27,19.78-20.71,19.51s-20.75-9.44-20.75-20.5,9.3-19.8,20.75-19.51S1137,494.15,1137,505.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1202.38,506.77c0,11-9.22,19.73-20.6,19.46s-20.63-9.42-20.63-20.45,9.24-19.74,20.63-19.46S1202.38,495.76,1202.38,506.77Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1838.31 663.62 1243.46 652.91 1243.46 487.86 1838.31 502.71 1838.31 663.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1301.33 642.33 1283.4 642 1283.4 508.73 1301.33 509.16 1301.33 642.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1333.14 642.92 1315.26 642.59 1315.26 509.5 1333.14 509.93 1333.14 642.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1364.87 643.5 1347.03 643.17 1347.03 510.26 1364.87 510.69 1364.87 643.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1396.5 644.09 1378.72 643.76 1378.72 511.03 1396.5 511.46 1396.5 644.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1428.06 644.67 1410.32 644.34 1410.32 511.79 1428.06 512.22 1428.06 644.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1459.53 645.25 1441.84 644.93 1441.84 512.55 1459.53 512.98 1459.53 645.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1490.91 645.83 1473.27 645.51 1473.27 513.31 1490.91 513.74 1490.91 645.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1522.22 646.41 1504.62 646.09 1504.62 514.07 1522.22 514.49 1522.22 646.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1553.43 646.99 1535.88 646.67 1535.88 514.82 1553.43 515.24 1553.43 646.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1584.57 647.57 1567.07 647.24 1567.07 515.57 1584.57 516 1584.57 647.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1615.62 648.14 1598.17 647.82 1598.17 516.32 1615.62 516.74 1615.62 648.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1646.59 648.71 1629.18 648.39 1629.18 517.07 1646.59 517.49 1646.59 648.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1677.48 649.29 1660.12 648.96 1660.12 517.82 1677.48 518.24 1677.48 649.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1708.29 649.86 1690.97 649.53 1690.97 518.56 1708.29 518.98 1708.29 649.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1739.02 650.42 1721.74 650.1 1721.74 519.3 1739.02 519.72 1739.02 650.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1769.66 650.99 1752.43 650.67 1752.43 520.04 1769.66 520.46 1769.66 650.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1800.22 651.56 1783.04 651.24 1783.04 520.78 1800.22 521.2 1800.22 651.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "1301.33 642.33 1283.4 642 1283.4 528.6 1301.33 529.01 1301.33 642.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1333.14 642.92 1315.26 642.59 1315.26 628.95 1333.14 629.29 1333.14 642.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "1364.87 643.5 1347.03 643.17 1347.03 565.76 1364.87 566.15 1364.87 643.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "1396.5 644.09 1378.72 643.76 1378.72 610.37 1396.5 610.73 1396.5 644.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "1428.06 644.67 1410.32 644.34 1410.32 558.95 1428.06 559.34 1428.06 644.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1459.53 645.25 1441.84 644.93 1441.84 586.12 1459.53 586.49 1459.53 645.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "1490.91 645.83 1473.27 645.51 1473.27 543.51 1490.91 543.91 1490.91 645.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "1522.22 646.41 1504.62 646.09 1504.62 533.75 1522.22 534.16 1522.22 646.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "1553.43 646.99 1535.88 646.67 1535.88 590.57 1553.43 590.94 1553.43 646.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "1584.57 647.57 1567.07 647.24 1567.07 524.59 1584.57 525 1584.57 647.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "1615.62 648.14 1598.17 647.82 1598.17 543.5 1615.62 543.9 1615.62 648.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "1646.59 648.71 1629.18 648.39 1629.18 620.46 1646.59 620.8 1646.59 648.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "1677.48 649.29 1660.12 648.96 1660.12 583.39 1677.48 583.76 1677.48 649.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "1708.29 649.86 1690.97 649.53 1690.97 555.15 1708.29 555.54 1708.29 649.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "1739.02 650.42 1721.74 650.1 1721.74 581.37 1739.02 581.74 1739.02 650.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "1769.66 650.99 1752.43 650.67 1752.43 544.19 1769.66 544.59 1769.66 650.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "1800.22 651.56 1783.04 651.24 1783.04 533.04 1800.22 533.44 1800.22 651.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M986.93,909V752.1c0-24,20.25-43.17,45.19-42.78l810.07,12.55a42.72,42.72,0,0,1,42,42.5V915.43a41.67,41.67,0,0,1-42,41.63l-810.07-4.32C1007.18,952.61,986.93,933,986.93,909Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1071.17,767.64c0,11.07-9.32,19.93-20.82,19.79s-20.86-9.24-20.86-20.33,9.34-20,20.86-19.8S1071.17,756.57,1071.17,767.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1137,768.5c0,11-9.27,19.88-20.71,19.74S1095.5,779,1095.5,768s9.3-19.9,20.75-19.74S1137,757.46,1137,768.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1202.38,769.36c0,11-9.22,19.82-20.6,19.68s-20.63-9.19-20.63-20.22,9.24-19.85,20.63-19.69S1202.38,758.35,1202.38,769.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1838.31 919.17 1243.46 915.03 1243.46 749.99 1838.31 758.27 1838.31 919.17"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1301.33 903.82 1283.4 903.68 1283.4 770.42 1301.33 770.65 1301.33 903.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1333.14 904.05 1315.26 903.92 1315.26 770.83 1333.14 771.07 1333.14 904.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1364.87 904.29 1347.03 904.16 1347.03 771.25 1364.87 771.48 1364.87 904.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1396.5 904.53 1378.72 904.39 1378.72 771.66 1396.5 771.89 1396.5 904.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1428.06 904.76 1410.32 904.63 1410.32 772.08 1428.06 772.31 1428.06 904.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1459.53 905 1441.84 904.86 1441.84 772.49 1459.53 772.72 1459.53 905"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1490.91 905.23 1473.27 905.1 1473.27 772.9 1490.91 773.13 1490.91 905.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1522.22 905.46 1504.62 905.33 1504.62 773.31 1522.22 773.54 1522.22 905.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1553.43 905.7 1535.88 905.56 1535.88 773.72 1553.43 773.95 1553.43 905.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1584.57 905.93 1567.07 905.8 1567.07 774.13 1584.57 774.35 1584.57 905.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1615.62 906.16 1598.17 906.03 1598.17 774.53 1615.62 774.76 1615.62 906.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1646.59 906.39 1629.18 906.26 1629.18 774.94 1646.59 775.17 1646.59 906.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1677.48 906.62 1660.12 906.49 1660.12 775.34 1677.48 775.57 1677.48 906.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1708.29 906.85 1690.97 906.72 1690.97 775.75 1708.29 775.97 1708.29 906.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1739.02 907.08 1721.74 906.95 1721.74 776.15 1739.02 776.37 1739.02 907.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1769.66 907.31 1752.43 907.18 1752.43 776.55 1769.66 776.77 1769.66 907.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1800.22 907.53 1783.04 907.4 1783.04 776.95 1800.22 777.17 1800.22 907.53"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1301.33 903.82 1283.4 903.68 1283.4 790.28 1301.33 790.5 1301.33 903.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1333.14 904.05 1315.26 903.92 1315.26 890.29 1333.14 890.43 1333.14 904.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1364.87 904.29 1347.03 904.16 1347.03 826.75 1364.87 826.94 1364.87 904.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1396.5 904.53 1378.72 904.39 1378.72 871.01 1396.5 871.16 1396.5 904.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1428.06 904.76 1410.32 904.63 1410.32 819.23 1428.06 819.43 1428.06 904.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1459.53 905 1441.84 904.86 1441.84 846.05 1459.53 846.23 1459.53 905"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1490.91 905.23 1473.27 905.1 1473.27 803.1 1490.91 803.31 1490.91 905.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1522.22 905.46 1504.62 905.33 1504.62 792.99 1522.22 793.21 1522.22 905.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1553.43 905.7 1535.88 905.56 1535.88 849.47 1553.43 849.64 1553.43 905.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1584.57 905.93 1567.07 905.8 1567.07 783.14 1584.57 783.36 1584.57 905.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1615.62 906.16 1598.17 906.03 1598.17 801.71 1615.62 801.91 1615.62 906.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1646.59 906.39 1629.18 906.26 1629.18 878.32 1646.59 878.47 1646.59 906.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1677.48 906.62 1660.12 906.49 1660.12 840.92 1677.48 841.1 1677.48 906.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1708.29 906.85 1690.97 906.72 1690.97 812.34 1708.29 812.54 1708.29 906.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1739.02 907.08 1721.74 906.95 1721.74 838.21 1739.02 838.39 1739.02 907.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1769.66 907.31 1752.43 907.18 1752.43 800.69 1769.66 800.9 1769.66 907.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1800.22 907.53 1783.04 907.4 1783.04 789.2 1800.22 789.42 1800.22 907.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M986.93,1174V1017.06c0-24,20.25-43.39,45.19-43.27l810.07,3.59a42.16,42.16,0,0,1,42,42v151.06a42.22,42.22,0,0,1-42,42.09l-810.07,4.64C1007.18,1217.35,986.93,1198,986.93,1174Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1071.17,1031.67c0,11.07-9.32,20-20.82,20s-20.86-9-20.86-20.11,9.34-20.06,20.86-20S1071.17,1020.6,1071.17,1031.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1137,1031.81c0,11-9.27,20-20.71,20s-20.75-9-20.75-20,9.3-20,20.75-20S1137,1020.77,1137,1031.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1202.38,1031.94c0,11-9.22,19.93-20.6,19.91s-20.63-9-20.63-20,9.24-19.95,20.63-19.92S1202.38,1020.93,1202.38,1031.94Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1838.31 1174.73 1243.46 1177.16 1243.46 1012.12 1838.31 1013.83 1838.31 1174.73"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1301.33 1165.31 1283.4 1165.37 1283.4 1032.1 1301.33 1032.14 1301.33 1165.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1333.14 1165.19 1315.26 1165.26 1315.26 1032.17 1333.14 1032.2 1333.14 1165.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1364.87 1165.08 1347.03 1165.14 1347.03 1032.23 1364.87 1032.27 1364.87 1165.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1396.5 1164.96 1378.72 1165.03 1378.72 1032.3 1396.5 1032.33 1396.5 1164.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1428.06 1164.85 1410.32 1164.91 1410.32 1032.36 1428.06 1032.4 1428.06 1164.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1459.53 1164.74 1441.84 1164.8 1441.84 1032.42 1459.53 1032.46 1459.53 1164.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1490.91 1164.62 1473.27 1164.69 1473.27 1032.49 1490.91 1032.53 1490.91 1164.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1522.22 1164.51 1504.62 1164.57 1504.62 1032.55 1522.22 1032.59 1522.22 1164.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1553.43 1164.4 1535.88 1164.46 1535.88 1032.62 1553.43 1032.65 1553.43 1164.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1584.57 1164.29 1567.07 1164.35 1567.07 1032.68 1584.57 1032.71 1584.57 1164.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1615.62 1164.17 1598.17 1164.24 1598.17 1032.74 1615.62 1032.78 1615.62 1164.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1646.59 1164.06 1629.18 1164.13 1629.18 1032.81 1646.59 1032.84 1646.59 1164.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1677.48 1163.95 1660.12 1164.02 1660.12 1032.87 1677.48 1032.9 1677.48 1163.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1708.29 1163.84 1690.97 1163.9 1690.97 1032.93 1708.29 1032.96 1708.29 1163.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1739.02 1163.73 1721.74 1163.79 1721.74 1032.99 1739.02 1033.03 1739.02 1163.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1769.66 1163.62 1752.43 1163.68 1752.43 1033.06 1769.66 1033.09 1769.66 1163.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1800.22 1163.51 1783.04 1163.57 1783.04 1033.12 1800.22 1033.15 1800.22 1163.51"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "1301.33 1165.31 1283.4 1165.37 1283.4 1051.97 1301.33 1051.99 1301.33 1165.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "1333.14 1165.19 1315.26 1165.26 1315.26 1151.62 1333.14 1151.57 1333.14 1165.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "1364.87 1165.08 1347.03 1165.14 1347.03 1087.73 1364.87 1087.72 1364.87 1165.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "1396.5 1164.96 1378.72 1165.03 1378.72 1131.64 1396.5 1131.6 1396.5 1164.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "1428.06 1164.85 1410.32 1164.91 1410.32 1079.52 1428.06 1079.52 1428.06 1164.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "1459.53 1164.74 1441.84 1164.8 1441.84 1105.99 1459.53 1105.97 1459.53 1164.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "1490.91 1164.62 1473.27 1164.69 1473.27 1062.69 1490.91 1062.7 1490.91 1164.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "1522.22 1164.51 1504.62 1164.57 1504.62 1052.24 1522.22 1052.26 1522.22 1164.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "1553.43 1164.4 1535.88 1164.46 1535.88 1108.37 1553.43 1108.35 1553.43 1164.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "1584.57 1164.29 1567.07 1164.35 1567.07 1041.69 1584.57 1041.72 1584.57 1164.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "1615.62 1164.17 1598.17 1164.24 1598.17 1059.92 1615.62 1059.93 1615.62 1164.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "1646.59 1164.06 1629.18 1164.13 1629.18 1136.19 1646.59 1136.15 1646.59 1164.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "1677.48 1163.95 1660.12 1164.02 1660.12 1098.44 1677.48 1098.43 1677.48 1163.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "1708.29 1163.84 1690.97 1163.9 1690.97 1069.52 1708.29 1069.53 1708.29 1163.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "1739.02 1163.73 1721.74 1163.79 1721.74 1095.05 1739.02 1095.04 1739.02 1163.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "1769.66 1163.62 1752.43 1163.68 1752.43 1057.2 1769.66 1057.22 1769.66 1163.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "1800.22 1163.51 1783.04 1163.57 1783.04 1045.37 1800.22 1045.4 1800.22 1163.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M986.93,1439V1282c0-24,20.25-43.62,45.19-43.78l810.07-5.35a41.59,41.59,0,0,1,42,41.57v151.06a42.79,42.79,0,0,1-42,42.55l-810.07,13.59C1007.18,1482.09,986.93,1463,986.93,1439Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1071.17,1295.71c0,11.07-9.32,20.13-20.82,20.25s-20.86-8.79-20.86-19.88,9.34-20.16,20.86-20.25S1071.17,1284.63,1071.17,1295.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1137,1295.11c0,11-9.27,20.09-20.71,20.2s-20.75-8.76-20.75-19.82,9.3-20.11,20.75-20.2S1137,1284.07,1137,1295.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1202.38,1294.52c0,11-9.22,20-20.6,20.14s-20.63-8.74-20.63-19.77,9.24-20,20.63-20.14S1202.38,1283.51,1202.38,1294.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1838.31 1430.29 1243.46 1439.29 1243.46 1274.25 1838.31 1269.38 1838.31 1430.29"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1301.33 1426.8 1283.4 1427.06 1283.4 1293.79 1301.33 1293.63 1301.33 1426.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1333.14 1426.33 1315.26 1426.59 1315.26 1293.5 1333.14 1293.34 1333.14 1426.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1364.87 1425.87 1347.03 1426.13 1347.03 1293.22 1364.87 1293.06 1364.87 1425.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1396.5 1425.4 1378.72 1425.66 1378.72 1292.93 1396.5 1292.77 1396.5 1425.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1428.06 1424.94 1410.32 1425.2 1410.32 1292.65 1428.06 1292.49 1428.06 1424.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1459.53 1424.48 1441.84 1424.74 1441.84 1292.36 1459.53 1292.2 1459.53 1424.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1490.91 1424.02 1473.27 1424.28 1473.27 1292.08 1490.91 1291.92 1490.91 1424.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1522.22 1423.56 1504.62 1423.82 1504.62 1291.8 1522.22 1291.64 1522.22 1423.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1553.43 1423.1 1535.88 1423.36 1535.88 1291.51 1553.43 1291.36 1553.43 1423.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1584.57 1422.65 1567.07 1422.9 1567.07 1291.23 1584.57 1291.07 1584.57 1422.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1615.62 1422.19 1598.17 1422.45 1598.17 1290.95 1615.62 1290.79 1615.62 1422.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1646.59 1421.74 1629.18 1421.99 1629.18 1290.67 1646.59 1290.52 1646.59 1421.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1677.48 1421.29 1660.12 1421.54 1660.12 1290.39 1677.48 1290.24 1677.48 1421.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1708.29 1420.83 1690.97 1421.09 1690.97 1290.11 1708.29 1289.96 1708.29 1420.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1739.02 1420.38 1721.74 1420.64 1721.74 1289.84 1739.02 1289.68 1739.02 1420.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1769.66 1419.93 1752.43 1420.19 1752.43 1289.56 1769.66 1289.4 1769.66 1419.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1800.22 1419.49 1783.04 1419.74 1783.04 1289.28 1800.22 1289.13 1800.22 1419.49"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1301.33 1426.8 1283.4 1427.06 1283.4 1313.66 1301.33 1313.48 1301.33 1426.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1333.14 1426.33 1315.26 1426.59 1315.26 1412.96 1333.14 1412.71 1333.14 1426.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1364.87 1425.87 1347.03 1426.13 1347.03 1348.71 1364.87 1348.51 1364.87 1425.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1396.5 1425.4 1378.72 1425.66 1378.72 1392.28 1396.5 1392.04 1396.5 1425.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1428.06 1424.94 1410.32 1425.2 1410.32 1339.8 1428.06 1339.61 1428.06 1424.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1459.53 1424.48 1441.84 1424.74 1441.84 1365.93 1459.53 1365.71 1459.53 1424.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1490.91 1424.02 1473.27 1424.28 1473.27 1322.28 1490.91 1322.1 1490.91 1424.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1522.22 1423.56 1504.62 1423.82 1504.62 1311.48 1522.22 1311.31 1522.22 1423.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1553.43 1423.1 1535.88 1423.36 1535.88 1367.27 1553.43 1367.05 1553.43 1423.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1584.57 1422.65 1567.07 1422.9 1567.07 1300.25 1584.57 1300.08 1584.57 1422.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1615.62 1422.19 1598.17 1422.45 1598.17 1318.13 1615.62 1317.95 1615.62 1422.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1646.59 1421.74 1629.18 1421.99 1629.18 1394.06 1646.59 1393.82 1646.59 1421.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1677.48 1421.29 1660.12 1421.54 1660.12 1355.97 1677.48 1355.76 1677.48 1421.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1708.29 1420.83 1690.97 1421.09 1690.97 1326.71 1708.29 1326.52 1708.29 1420.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1739.02 1420.38 1721.74 1420.64 1721.74 1351.9 1739.02 1351.7 1739.02 1420.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1769.66 1419.93 1752.43 1420.19 1752.43 1313.7 1769.66 1313.53 1769.66 1419.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1800.22 1419.49 1783.04 1419.74 1783.04 1301.54 1800.22 1301.37 1800.22 1419.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M986.93,1703.92V1547c0-24,20.25-43.84,45.19-44.28l810.07-14.3a41.05,41.05,0,0,1,42,41.11v151.06a43.37,43.37,0,0,1-42,43l-810.07,22.54C1007.18,1746.83,986.93,1727.93,986.93,1703.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1071.17,1559.74c0,11.07-9.32,20.24-20.82,20.48s-20.86-8.55-20.86-19.64,9.34-20.27,20.86-20.49S1071.17,1548.67,1071.17,1559.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1137,1558.42c0,11-9.27,20.18-20.71,20.42s-20.75-8.53-20.75-19.59,9.3-20.2,20.75-20.42S1137,1547.38,1137,1558.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1202.38,1557.11c0,11-9.22,20.12-20.6,20.36s-20.63-8.51-20.63-19.54,9.24-20.15,20.63-20.37S1202.38,1546.09,1202.38,1557.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1838.31 1685.84 1243.46 1701.42 1243.46 1536.38 1838.31 1524.94 1838.31 1685.84"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1301.33 1688.29 1283.4 1688.75 1283.4 1555.48 1301.33 1555.12 1301.33 1688.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1333.14 1687.47 1315.26 1687.93 1315.26 1554.84 1333.14 1554.48 1333.14 1687.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1364.87 1686.65 1347.03 1687.11 1347.03 1554.2 1364.87 1553.84 1364.87 1686.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1396.5 1685.84 1378.72 1686.3 1378.72 1553.57 1396.5 1553.21 1396.5 1685.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1428.06 1685.03 1410.32 1685.48 1410.32 1552.93 1428.06 1552.58 1428.06 1685.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1459.53 1684.22 1441.84 1684.67 1441.84 1552.3 1459.53 1551.94 1459.53 1684.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1490.91 1683.41 1473.27 1683.87 1473.27 1551.67 1490.91 1551.31 1490.91 1683.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1522.22 1682.61 1504.62 1683.06 1504.62 1551.04 1522.22 1550.69 1522.22 1682.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1553.43 1681.81 1535.88 1682.26 1535.88 1550.41 1553.43 1550.06 1553.43 1681.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1584.57 1681.01 1567.07 1681.46 1567.07 1549.79 1584.57 1549.43 1584.57 1681.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1615.62 1680.21 1598.17 1680.66 1598.17 1549.16 1615.62 1548.81 1615.62 1680.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1646.59 1679.41 1629.18 1679.86 1629.18 1548.54 1646.59 1548.19 1646.59 1679.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1677.48 1678.62 1660.12 1679.07 1660.12 1547.92 1677.48 1547.57 1677.48 1678.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1708.29 1677.83 1690.97 1678.27 1690.97 1547.3 1708.29 1546.95 1708.29 1677.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1739.02 1677.04 1721.74 1677.48 1721.74 1546.68 1739.02 1546.34 1739.02 1677.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1769.66 1676.25 1752.43 1676.69 1752.43 1546.07 1769.66 1545.72 1769.66 1676.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1800.22 1675.46 1783.04 1675.91 1783.04 1545.45 1800.22 1545.11 1800.22 1675.46"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "1301.33 1688.29 1283.4 1688.75 1283.4 1575.35 1301.33 1574.97 1301.33 1688.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "1333.14 1687.47 1315.26 1687.93 1315.26 1674.29 1333.14 1673.84 1333.14 1687.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "1364.87 1686.65 1347.03 1687.11 1347.03 1609.7 1364.87 1609.3 1364.87 1686.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "1396.5 1685.84 1378.72 1686.3 1378.72 1652.91 1396.5 1652.48 1396.5 1685.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "1428.06 1685.03 1410.32 1685.48 1410.32 1600.09 1428.06 1599.69 1428.06 1685.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "1459.53 1684.22 1441.84 1684.67 1441.84 1625.87 1459.53 1625.45 1459.53 1684.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "1490.91 1683.41 1473.27 1683.87 1473.27 1581.87 1490.91 1581.49 1490.91 1683.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "1522.22 1682.61 1504.62 1683.06 1504.62 1570.72 1522.22 1570.35 1522.22 1682.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "1553.43 1681.81 1535.88 1682.26 1535.88 1626.16 1553.43 1625.75 1553.43 1681.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "1584.57 1681.01 1567.07 1681.46 1567.07 1558.8 1584.57 1558.44 1584.57 1681.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "1615.62 1680.21 1598.17 1680.66 1598.17 1576.34 1615.62 1575.96 1615.62 1680.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "1646.59 1679.41 1629.18 1679.86 1629.18 1651.92 1646.59 1651.5 1646.59 1679.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "1677.48 1678.62 1660.12 1679.07 1660.12 1613.49 1677.48 1613.09 1677.48 1678.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "1708.29 1677.83 1690.97 1678.27 1690.97 1583.89 1708.29 1583.52 1708.29 1677.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "1739.02 1677.04 1721.74 1677.48 1721.74 1608.74 1739.02 1608.35 1739.02 1677.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "1769.66 1676.25 1752.43 1676.69 1752.43 1570.21 1769.66 1569.85 1769.66 1676.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "1800.22 1675.46 1783.04 1675.91 1783.04 1557.7 1800.22 1557.35 1800.22 1675.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M986.93,1968.88V1812c0-24,20.25-44.06,45.19-44.77l810.07-23.26a40.52,40.52,0,0,1,42,40.65v151c0,23.12-18.8,42.59-42,43.49l-810.07,31.49C1007.18,2011.57,986.93,1992.89,986.93,1968.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1071.17,1823.77c0,11.07-9.32,20.35-20.82,20.71s-20.86-8.32-20.86-19.41,9.34-20.37,20.86-20.71S1071.17,1812.7,1071.17,1823.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1137,1821.72c0,11-9.27,20.29-20.71,20.66s-20.75-8.31-20.75-19.37,9.3-20.3,20.75-20.65S1137,1810.68,1137,1821.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1202.38,1819.69c0,11-9.22,20.23-20.6,20.59s-20.63-8.28-20.63-19.31,9.24-20.25,20.63-20.59S1202.38,1808.68,1202.38,1819.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1838.31 1941.4 1243.46 1963.55 1243.46 1798.51 1838.31 1780.49 1838.31 1941.4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1301.33 1949.78 1283.4 1950.43 1283.4 1817.17 1301.33 1816.61 1301.33 1949.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1333.14 1948.61 1315.26 1949.26 1315.26 1816.18 1333.14 1815.62 1333.14 1948.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1364.87 1947.44 1347.03 1948.1 1347.03 1815.19 1364.87 1814.63 1364.87 1947.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1396.5 1946.28 1378.72 1946.93 1378.72 1814.2 1396.5 1813.65 1396.5 1946.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1428.06 1945.12 1410.32 1945.77 1410.32 1813.22 1428.06 1812.66 1428.06 1945.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1459.53 1943.96 1441.84 1944.61 1441.84 1812.24 1459.53 1811.69 1459.53 1943.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1490.91 1942.81 1473.27 1943.46 1473.27 1811.26 1490.91 1810.71 1490.91 1942.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1522.22 1941.66 1504.62 1942.31 1504.62 1810.28 1522.22 1809.73 1522.22 1941.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1553.43 1940.51 1535.88 1941.16 1535.88 1809.31 1553.43 1808.76 1553.43 1940.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1584.57 1939.37 1567.07 1940.01 1567.07 1808.34 1584.57 1807.79 1584.57 1939.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1615.62 1938.22 1598.17 1938.87 1598.17 1807.37 1615.62 1806.83 1615.62 1938.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1646.59 1937.09 1629.18 1937.73 1629.18 1806.41 1646.59 1805.86 1646.59 1937.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1677.48 1935.95 1660.12 1936.59 1660.12 1805.44 1677.48 1804.9 1677.48 1935.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1708.29 1934.82 1690.97 1935.46 1690.97 1804.48 1708.29 1803.94 1708.29 1934.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1739.02 1933.69 1721.74 1934.33 1721.74 1803.53 1739.02 1802.99 1739.02 1933.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1769.66 1932.57 1752.43 1933.2 1752.43 1802.57 1769.66 1802.03 1769.66 1932.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1800.22 1931.44 1783.04 1932.07 1783.04 1801.62 1800.22 1801.08 1800.22 1931.44"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1301.33 1949.78 1283.4 1950.43 1283.4 1837.04 1301.33 1836.46 1301.33 1949.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1333.14 1948.61 1315.26 1949.26 1315.26 1935.63 1333.14 1934.98 1333.14 1948.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1364.87 1947.44 1347.03 1948.1 1347.03 1870.68 1364.87 1870.09 1364.87 1947.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1396.5 1946.28 1378.72 1946.93 1378.72 1913.55 1396.5 1912.92 1396.5 1946.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1428.06 1945.12 1410.32 1945.77 1410.32 1860.37 1428.06 1859.78 1428.06 1945.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1459.53 1943.96 1441.84 1944.61 1441.84 1885.8 1459.53 1885.2 1459.53 1943.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1490.91 1942.81 1473.27 1943.46 1473.27 1841.46 1490.91 1840.89 1490.91 1942.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1522.22 1941.66 1504.62 1942.31 1504.62 1829.97 1522.22 1829.4 1522.22 1941.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1553.43 1940.51 1535.88 1941.16 1535.88 1885.06 1553.43 1884.46 1553.43 1940.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1584.57 1939.37 1567.07 1940.01 1567.07 1817.36 1584.57 1816.8 1584.57 1939.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1615.62 1938.22 1598.17 1938.87 1598.17 1834.55 1615.62 1833.98 1615.62 1938.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1646.59 1937.09 1629.18 1937.73 1629.18 1909.79 1646.59 1909.17 1646.59 1937.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1677.48 1935.95 1660.12 1936.59 1660.12 1871.02 1677.48 1870.43 1677.48 1935.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1708.29 1934.82 1690.97 1935.46 1690.97 1841.07 1708.29 1840.51 1708.29 1934.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1739.02 1933.69 1721.74 1934.33 1721.74 1865.59 1739.02 1865 1739.02 1933.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1769.66 1932.57 1752.43 1933.2 1752.43 1826.71 1769.66 1826.16 1769.66 1932.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1800.22 1931.44 1783.04 1932.07 1783.04 1813.87 1800.22 1813.33 1800.22 1931.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M986.93,2233.84V2076.92c0-24,20.25-44.29,45.19-45.28l810.07-32.2a40,40,0,0,1,42,40.18v151.05c0,23.12-18.8,42.79-42,43.95l-810.07,40.45C1007.18,2276.31,986.93,2257.86,986.93,2233.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1071.17,2087.8c0,11.08-9.32,20.45-20.82,20.95s-20.86-8.1-20.86-19.19,9.34-20.47,20.86-20.94S1071.17,2076.73,1071.17,2087.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1137,2085c0,11-9.27,20.39-20.71,20.88s-20.75-8.07-20.75-19.13,9.3-20.41,20.75-20.89S1137,2074,1137,2085Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1202.38,2082.27c0,11-9.22,20.33-20.6,20.82s-20.63-8.05-20.63-19.08,9.24-20.35,20.63-20.82S1202.38,2071.26,1202.38,2082.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1838.31 2196.96 1243.46 2225.68 1243.46 2060.64 1838.31 2036.05 1838.31 2196.96"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1301.33 2211.26 1283.4 2212.12 1283.4 2078.85 1301.33 2078.1 1301.33 2211.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1333.14 2209.74 1315.26 2210.6 1315.26 2077.51 1333.14 2076.76 1333.14 2209.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1364.87 2208.23 1347.03 2209.08 1347.03 2076.17 1364.87 2075.42 1364.87 2208.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1396.5 2206.72 1378.72 2207.57 1378.72 2074.84 1396.5 2074.09 1396.5 2206.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1428.06 2205.21 1410.32 2206.05 1410.32 2073.5 1428.06 2072.76 1428.06 2205.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1459.53 2203.7 1441.84 2204.55 1441.84 2072.17 1459.53 2071.43 1459.53 2203.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1490.91 2202.2 1473.27 2203.05 1473.27 2070.85 1490.91 2070.1 1490.91 2202.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1522.22 2200.71 1504.62 2201.55 1504.62 2069.53 1522.22 2068.78 1522.22 2200.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1553.43 2199.22 1535.88 2200.05 1535.88 2068.21 1553.43 2067.47 1553.43 2199.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1584.57 2197.73 1567.07 2198.56 1567.07 2066.89 1584.57 2066.15 1584.57 2197.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1615.62 2196.24 1598.17 2197.08 1598.17 2065.58 1615.62 2064.84 1615.62 2196.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1646.59 2194.76 1629.18 2195.59 1629.18 2064.27 1646.59 2063.54 1646.59 2194.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1677.48 2193.29 1660.12 2194.12 1660.12 2062.97 1677.48 2062.24 1677.48 2193.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1708.29 2191.81 1690.97 2192.64 1690.97 2061.67 1708.29 2060.94 1708.29 2191.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1739.02 2190.34 1721.74 2191.17 1721.74 2060.37 1739.02 2059.64 1739.02 2190.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1769.66 2188.88 1752.43 2189.7 1752.43 2059.08 1769.66 2058.35 1769.66 2188.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1800.22 2187.42 1783.04 2188.24 1783.04 2057.78 1800.22 2057.06 1800.22 2187.42"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1301.33 2211.26 1283.4 2212.12 1283.4 2098.72 1301.33 2097.95 1301.33 2211.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1333.14 2209.74 1315.26 2210.6 1315.26 2196.97 1333.14 2196.12 1333.14 2209.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1364.87 2208.23 1347.03 2209.08 1347.03 2131.67 1364.87 2130.88 1364.87 2208.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1396.5 2206.72 1378.72 2207.57 1378.72 2174.18 1396.5 2173.36 1396.5 2206.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1428.06 2205.21 1410.32 2206.05 1410.32 2120.66 1428.06 2119.87 1428.06 2205.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1459.53 2203.7 1441.84 2204.55 1441.84 2145.74 1459.53 2144.94 1459.53 2203.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1490.91 2202.2 1473.27 2203.05 1473.27 2101.05 1490.91 2100.28 1490.91 2202.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1522.22 2200.71 1504.62 2201.55 1504.62 2089.21 1522.22 2088.45 1522.22 2200.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1553.43 2199.22 1535.88 2200.05 1535.88 2143.96 1553.43 2143.16 1553.43 2199.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1584.57 2197.73 1567.07 2198.56 1567.07 2075.91 1584.57 2075.16 1584.57 2197.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1615.62 2196.24 1598.17 2197.08 1598.17 2092.75 1615.62 2092 1615.62 2196.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1646.59 2194.76 1629.18 2195.59 1629.18 2167.66 1646.59 2166.85 1646.59 2194.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1677.48 2193.29 1660.12 2194.12 1660.12 2128.54 1677.48 2127.76 1677.48 2193.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1708.29 2191.81 1690.97 2192.64 1690.97 2098.26 1708.29 2097.5 1708.29 2191.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1739.02 2190.34 1721.74 2191.17 1721.74 2122.43 1739.02 2121.66 1739.02 2190.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1769.66 2188.88 1752.43 2189.7 1752.43 2083.22 1769.66 2082.47 1769.66 2188.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1800.22 2187.42 1783.04 2188.24 1783.04 2070.04 1800.22 2069.3 1800.22 2187.42"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1796.89,2098.53c-131.48-177.36-300.64-172.57-348.66-338.87-51.37-177.91,116.24-255.17,74-448.35C1479.28,1115,1273.34,1113.45,1243.46,915c-24.25-161,104.38-207.48,62.35-351.95-43-147.81-197.26-168-227.7-312.6-9.45-44.9-4-88,8.47-126.69l-97.43-3.9c-35.14-1.41-63.7,24.84-63.7,58.62V2395.91c0,33.78,28.56,59.53,63.7,57.52l893-51.15a61.15,61.15,0,0,0,25.34-7.23C1891.06,2256.48,1844.76,2163.11,1796.89,2098.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1365.48,967.82l-1223.67-.41c-26.19.23-45.62,31-42.32,55.7L302,2541.22c4.64,34.79,40,43.05,66.21,41.22L1579.61,2498c23.75-1.65,40.27-22.3,36.93-46.11l-202.11-1442C1411.14,986.47,1389.24,967.62,1365.48,967.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1385.13,953.74,157.94,964.47c-26.24.23-44.86,20.6-41.54,45.5L320.81,2541.55c3.37,25.31,27.43,44.32,53.67,42.47l1226.87-86.41c23.8-1.67,40.34-22.51,37-46.54L1434.24,996.21C1430.92,972.54,1409,953.53,1385.13,953.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M371.68,2563c-14.17,1-27.19-9.31-29-23L138.26,1009.74c-1.8-13.44,8.28-24.48,22.44-24.61l1227.19-11.69c12.87-.12,24.78,10.18,26.58,23l204.09,1456c1.82,13-7.15,24.28-20,25.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1507.49 2436.07 457.31 2507.19 266.49 1085.07 1316.91 1071.05 1507.49 2436.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M884.6,1099.84l-411.81,25.54-3.46-92.85c-.94-12,6.26-22.36,17.27-24.75l67.17-14.55a22.45,22.45,0,0,0,16.69-15.55l5.26-16.86,184.14.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M1104.56,1026.36a25.66,25.66,0,0,0-24.66-17.74l-69.19.69c-31.23.32-57.34-23.26-60.53-54.75l-7.41-72.94a26.07,26.07,0,0,0-26-23.6l-22.43.09c-17.07.07-30.35-14-30.33-31.24A54.14,54.14,0,0,0,809.9,772.4c-30.15,0-54.83,24.61-55.14,55a31.45,31.45,0,0,1-31.27,31.44l-22.62.09A27.25,27.25,0,0,0,674,883l-8.65,73.84a64.27,64.27,0,0,1-63,56.61l-71.84.72a28,28,0,0,0-26.07,18.68l-31,88.16a10.82,10.82,0,0,0,10.42,14.48l638.88-9.41a11,11,0,0,0,10.11-14.41ZM809.44,835.48a15.86,15.86,0,0,1-15.9-16.07,16.25,16.25,0,0,1,16.14-16.16,15.87,15.87,0,0,1,15.88,16.08A16.25,16.25,0,0,1,809.44,835.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1108.74,1028.14a25.67,25.67,0,0,0-24.67-17.74l-69.23.69c-31.24.31-57.36-23.28-60.55-54.78l-7.41-72.95a26.08,26.08,0,0,0-26-23.61l-22.44.09c-17.07.07-30.36-14-30.34-31.25A54.17,54.17,0,0,0,814,774.09c-30.17,0-54.86,24.62-55.17,55a31.46,31.46,0,0,1-31.28,31.45l-22.64.09A27.25,27.25,0,0,0,678,884.68l-8.66,73.85a64.28,64.28,0,0,1-63,56.62l-71.87.72a28,28,0,0,0-26.09,18.68l-31,88.17a10.83,10.83,0,0,0,10.42,14.49l639.17-9.35a11,11,0,0,0,10.12-14.41ZM813.48,837.2a15.89,15.89,0,0,1-15.91-16.09A16.27,16.27,0,0,1,813.72,805,15.89,15.89,0,0,1,829.61,821,16.26,16.26,0,0,1,813.48,837.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M1002.3,1074.74c-62.73-32.3-103.43-5.06-144.55-42.78-43.82-40.2-25.84-97.28-68.66-121.15-27.31-15.22-47.55.89-77.1-1.87-10.79-1-22.63-4.52-35.44-12l-7.22,61.59a64.28,64.28,0,0,1-63,56.62l-71.87.72a28,28,0,0,0-26.09,18.68l-31,88.17a10.83,10.83,0,0,0,10.42,14.49l578.9-8.47C1048.41,1106,1027.14,1087.54,1002.3,1074.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M625.75,1220.49c4.76,35.11-8.64,69.53-30.94,69.75s-45.15-34-49.92-69.21,11.47-49.38,33.83-49.48S621,1185.38,625.75,1220.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M800.13,1636.46c-2.32-4.83-8.27-8.64-13-11a14.83,14.83,0,0,1-8-10.24l-9-47.22-3.11-23c-3.12-23-5.85-43.15-17-60.25s-18.24-68.93-18.24-68.93c-5.23-60.5-35.65-65.89-54.64-74.32-13.57-6-33.82-16.39-44.32-21.85a18.21,18.21,0,0,1-9-10.62l-7.76-25.2c-5.32,7.55-12.25,12.19-20.38,12.27s-16.33-4.41-23.7-11.85l-.94,25.34a13.11,13.11,0,0,1-6.17,10.82c-9.06,5.7-26.61,16.57-38.67,22.94-16.91,8.94-46.35,15.14-35,76.24,0,0,7.1,52.39.39,70s-4,38-.79,61.35l3.16,23.31,3.87,48a11.45,11.45,0,0,1-5.34,10.72c-4.18,2.67-9.21,6.82-10.25,11.8-1.85,8.83-11.61,26.66-20.32,29.82,0,0,.79,5.84,6.86,5.67s14-9.16,14-9.16l.59,44.75a5.16,5.16,0,0,0,5.29,4.85,4,4,0,0,0,4.07-3.8l1.51-28.56L499,1724.6a5.19,5.19,0,0,0,5.24,4.33h.16a4,4,0,0,0,4.06-4.26l-1.88-33.84,6.85,30.8a5.22,5.22,0,0,0,5.17,3.95h.18a4,4,0,0,0,4-4.59l-1.5-33.48,5.29,22.65a5.26,5.26,0,0,0,5,3.36l2.33-.07s0-57.48-10.82-75.07a10.67,10.67,0,0,1-1.07-8.85c6.3-19.7,26.57-88,14.85-117.51,0,0-.53-26.22,1.3-35,0,0,14.8,20.11,18.34,46.25s-8.47,93.45-3.74,128.33,7.62,78.58,24.78,116,21.87,72.22,23.44,83.84,5.66,64,11,81.32,27.82,71.84,36.56,91.89,4.72,34.82,2.91,43.65-9.62,18-2.84,23.49,30.68,4.41,30.68,4.41,14.53-3.59,17.12-6.63-7.85-57.92-7.85-57.92-13.27-31.47-16.18-75.05-2.66-63.95-13.58-78.1c0,0-1.73-34.87-4.08-52.25s-3.6-93-9.33-113.14l-8.81-31a7.43,7.43,0,0,1,7.16-9.66l5.58-.15c5.18-.14,9.76,4.2,9.7,9.19l-.36,31.22c-.24,20.35,18.9,95.31,21.26,112.67s10,52,10,52c-7,14.8-1.25,34.94,7.61,78.23s4.24,75.48,4.24,75.48,4.48,55.13,7.85,57.89,18.63,4.95,18.63,4.95,23.75-1.11,28.9-7.16-4.92-14.31-9.06-22.84-12-22.71-8.84-43.2,10.58-75.94,11.2-93.37-9.39-69.26-10.95-80.81-6.26-46.17.51-84.06-2.05-81-6.74-115.61-34.45-100.46-38-126.43A93.43,93.43,0,0,1,701,1474c4.14,8.6,10.62,34.49,10.62,34.49-3.58,29.62,34.43,96,45.8,115.06a10.72,10.72,0,0,1,1.31,8.74c-5.83,17.84,9.44,74.31,9.44,74.31l2.28-.07a3.94,3.94,0,0,0,3.94-3.58l-.87-22.52L781,1713.4a5.09,5.09,0,0,0,5.12,4.27h.17a4,4,0,0,0,4-4.18l-1.53-30.55,7.14,33.25a5.1,5.1,0,0,0,5,3.93H801a4,4,0,0,0,3.91-4.54l-4.85-35.85,9,27.86a5.12,5.12,0,0,0,4.92,3.49,4,4,0,0,0,3.81-5l-11.25-43.78s10,8.37,15.87,8.21,5.1-5.9,5.1-5.9C818.35,1661.93,804.24,1645,800.13,1636.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "1243.27 1212.16 767.89 1215.24 763.22 1180.79 1238.71 1178.47 1243.27 1212.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M737.91,1539.19c-20.21,0-38.66-15.78-41.34-35.55a33.23,33.23,0,0,1,7.53-26.47,34.22,34.22,0,0,1,25.84-11.74h.7c20.2,0,38.67,15.81,41.34,35.55a33.24,33.24,0,0,1-7.5,26.44,34.19,34.19,0,0,1-25.75,11.77Zm-7.25-63.38h-.53a24,24,0,0,0-18.14,8.12,23,23,0,0,0-5.12,18.32c2,15,16.22,26.81,31.64,26.55a24,24,0,0,0,18.07-8.14,23,23,0,0,0,5.11-18.29h0C759.69,1487.62,745.83,1475.81,730.66,1475.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M712.34,1881.71c-20.1,0-38.3-15.49-41-35.15a33.74,33.74,0,0,1,7.53-26.65,34.86,34.86,0,0,1,25.89-12.19c20.6-.77,39.56,15.07,42.28,35.13a33.75,33.75,0,0,1-7.49,26.61,34.85,34.85,0,0,1-25.81,12.22Zm-6.21-63.62-1,0a24.6,24.6,0,0,0-18.3,8.5,23.44,23.44,0,0,0-5.17,18.55c2,15,16.14,26.74,31.72,26.14a24.59,24.59,0,0,0,18.24-8.53,23.49,23.49,0,0,0,5.15-18.52h0C734.8,1829.63,721.16,1818.09,706.13,1818.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M778.63,1506.63a5.2,5.2,0,0,1-.1-10.39l76.37-1.5H855a5.2,5.2,0,0,1,.1,10.39l-76.38,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M756.73,1848.22a5.19,5.19,0,0,1-.18-10.38l135.31-4.78a5.27,5.27,0,0,1,5.38,5,5.19,5.19,0,0,1-5,5.37l-135.31,4.78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "1282.47 1501.4 872.45 1509.64 869.74 1489.6 1279.81 1481.75 1282.47 1501.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "1188.27 1538.12 877.23 1544.87 875.55 1532.54 1186.62 1525.96 1188.27 1538.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "1191.79 1564.16 880.81 1571.29 879.13 1558.96 1190.15 1552 1191.79 1564.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "1195.32 1590.2 884.39 1597.71 882.72 1585.38 1193.68 1578.05 1195.32 1590.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "1198.85 1616.24 887.97 1624.13 886.3 1611.8 1197.2 1604.09 1198.85 1616.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "1327.38 1832.77 918.23 1847.4 915.51 1827.36 1324.72 1813.11 1327.38 1832.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "1233.38 1871.02 923 1882.63 921.33 1870.3 1231.73 1858.87 1233.38 1871.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "1236.91 1897.06 926.58 1909.05 924.91 1896.72 1235.26 1884.91 1236.91 1897.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "1240.44 1923.1 930.16 1935.47 928.49 1923.14 1238.79 1910.95 1240.44 1923.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "1243.97 1949.15 933.74 1961.89 932.07 1949.56 1242.32 1936.99 1243.97 1949.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "865.08 1288.51 777.93 1289.37 772.75 1251.12 859.92 1250.42 865.08 1288.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "871.64 1336.86 784.51 1337.92 779.33 1299.67 866.47 1298.77 871.64 1336.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "878.19 1385.21 791.09 1386.46 785.91 1348.21 873.03 1347.12 878.19 1385.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "884.74 1433.57 797.67 1435.01 792.49 1396.76 879.58 1395.47 884.74 1433.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "963.41 1287.54 877.05 1288.39 871.89 1250.32 958.27 1249.62 963.41 1287.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M882.09,1338.47l-5.63-41.54,89.84-.93,5.61,41.38Zm-1.67-38.12,4.69,34.62,82.84-1-4.67-34.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M888.64,1386.8,883,1345.26l89.82-1.13,5.6,41.38ZM887,1348.67l4.69,34.62,82.82-1.19-4.67-34.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M895.19,1435.12l-5.63-41.53,89.79-1.33,5.61,41.38ZM893.52,1397l4.69,34.61,82.79-1.37-4.67-34.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "1060.85 1286.58 975.27 1287.42 970.13 1249.52 1055.73 1248.83 1060.85 1286.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M980.27,1337.28l-5.6-41.37,89.06-.91,5.59,41.2Zm-1.64-37.94,4.67,34.44,82.06-1-4.65-34.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M986.79,1385.39l-5.6-41.36,89-1.12,5.58,41.2Zm-1.64-38,4.66,34.44,82-1.18-4.64-34.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M993.32,1433.5l-5.61-41.36,89-1.32,5.59,41.2Zm-1.65-38,4.67,34.44,82-1.36-4.65-34.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "1157.4 1285.63 1072.6 1286.46 1067.48 1248.73 1152.31 1248.04 1157.4 1285.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1077.58,1336.1l-5.59-41.19,88.3-.91,5.56,41Zm-1.63-37.77,4.65,34.27,81.29-1-4.62-34.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1084.07,1384l-5.59-41.19,88.27-1.11,5.56,41Zm-1.63-37.77,4.65,34.27,81.27-1.17-4.63-34.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1090.56,1431.88l-5.59-41.19,88.25-1.3,5.56,41Zm-1.63-37.78,4.65,34.27,81.24-1.35-4.62-34.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "1253.1 1284.68 1169.05 1285.51 1163.96 1247.95 1248.03 1247.27 1253.1 1284.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1174,1334.93l-5.56-41,87.54-.9,5.53,40.86Zm-1.6-37.6,4.62,34.1,80.54-1-4.6-34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1180.46,1382.61l-5.56-41,87.51-1.1,5.54,40.86Zm-1.6-37.61,4.62,34.1L1264,1378l-4.6-34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1186.92,1430.29l-5.56-41,87.49-1.3,5.54,40.87Zm-1.6-37.62,4.62,34.1,80.49-1.33-4.6-34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "957.65 2207.11 508.73 2230.67 502 2180.97 951.05 2158.43 957.65 2207.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "1401.4 2185.23 970.94 2207.85 964.35 2159.2 1394.94 2137.55 1401.4 2185.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M515.38,2292.65l-4.65-34.38L963,2233.93l4.58,33.73Zm-.72-31.12,3.73,27.48,445.28-24.6L960,2237.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M977.35,2268l-4.57-33.72,433.85-23.37,4.49,33.11Zm-.63-30.47,3.63,26.84,426.83-23.6-3.55-26.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M983.87,2316.12l-4.57-33.73L1413,2258.06l4.49,33.11-1.87.11Zm-.64-30.48,3.64,26.84,426.7-24.55-3.55-26.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M528.7,2390.9,524,2356.52l452-26.36,4.58,33.74Zm-.72-31.14,3.72,27.49,445-26.59-3.64-26.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M990.38,2364.21l-4.57-33.72,433.6-25.31,4.48,33.12Zm-.63-30.48,3.63,26.83,426.58-25.5-3.55-26.23Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1929.21,1102.61l-27.16-1.64c-23.2-.62-75.93,17.22-75.55,39.85l.13,8.08c-3.51,34.61,48.93,41.31,72.12,41.72l31.94,1.08a39.53,39.53,0,0,0,37.5-23.85,132.4,132.4,0,0,1,35.86,11l.33-35a165.76,165.76,0,0,0-34.51-8.89A43.29,43.29,0,0,0,1929.21,1102.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1823.06,2098.35a45,45,0,0,0-32.65,11.35l-42.34,37.5a83.29,83.29,0,0,1-22.2,14.1,42.16,42.16,0,0,0-24.28-5.18,47,47,0,0,0-25.42,10.06,73,73,0,0,1-26.11-11.59l-43.55-30.94c-10.08-7.16-22.73-9.24-34.68-6.73l-123.43-75.54c-103.3-63.21-167.13-172.6-169.11-291.6-.17-10.37-5.94-19.32-14.62-24.58l-7.26-437.14c-1.14-68.62,53.32-124.36,124-132,7.29,15.41,23.76,26.41,42.7,26.74l17.86,1.18c24.89.44,93.75-18.09,93.37-41.38l-.14-8.32c-.39-23.29-57.78-42.71-82.67-43.38l-30-1.79c-21.77-.59-39.82,13.09-44.22,32-90.59,8.26-161,79.1-159.56,166.75l7.28,438.75c-8.57,5.88-14.1,15.29-13.93,25.73a400.84,400.84,0,0,0,55,195.64c34.55,58.87,84.38,109,143.77,144.9L1535.18,2168a38,38,0,0,0,15.73,24.08l44,30.82a153.43,153.43,0,0,0,44.13,21.27l108.54-4.56a176.76,176.76,0,0,0,55.58-33.73l41.88-37.55a43.51,43.51,0,0,0,14.17-25.87Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M689.39,2806.05c-68.38,0-134.64-12.67-185.64-36.34-48.16-22.36-73.06-50.65-70.11-79.67s31.76-50.11,85.66-62.85c258.33-61.06,1087.1-78.68,1389.2-75.74,113,1.06,180-9,216.25-17.64,50.41-12,62-25.8,62.32-28.83-.23-2.24-8.12-13-42.55-23.83-35.68-11.25-86.6-18.51-147.25-21-48.83-2-91.14-28.76-122.38-77.42a268.22,268.22,0,0,1-32-71.4l33.23-8.43c.3,1.19,31.6,119.29,122.53,123,65.28,2.66,120.26,10.77,159,23.45,42.86,14,64.29,33,63.7,56.49-.66,26.44-29.71,46.88-86.32,60.74-54.85,13.42-133.3,20.06-226.86,19.13-300.85-2.95-1125.53,14.44-1381,74.82-42.43,10-58.54,24-59.44,32.95-1,10,14.33,28.35,50.44,45.11,117,54.3,352.82,57.11,511-106.64l24.66,23.81c-99.13,102.65-216.28,136.14-297.11,146.15A548.5,548.5,0,0,1,689.39,2806.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1454.45,1183.93l-18-1.18c-25.4-.45-48.92-20-52.43-43.65l-1.25-8.44c-3.51-23.65,14.36-42.28,39.79-41.6l30.21,1.79c25,.67,84.93,20.09,88.38,43.39l1.23,8.31C1545.82,1165.84,1479.39,1184.37,1454.45,1183.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1797.66,2221.14l-248.09-139.31c-62.11-34.87-116.76-83.48-157.71-140.54-41.2-57.42-68.3-123.06-78.16-189.56l-68.78-464c-13.44-90.6,52.29-163.24,146.72-167.38a14.71,14.71,0,0,1,15.12,12.58l.85,5.77a14.76,14.76,0,0,1-13.47,16.85c-71.81,6-120.89,62.56-110.52,132.47l68.53,462.24c18.28,123.31,99.42,236.6,215.12,302l247.18,139.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1810.43,2236.12a33,33,0,0,1-19-4.15L1543,2092.79c-64.12-35.92-120.56-86-162.85-144.9-42.57-59.24-70.56-127-80.74-195.64-2.52-17,10.48-31.38,29-32s35.38,12.6,37.89,29.54c17.64,119,95.88,228.39,207.5,291.6l246.85,139.8c15,8.51,20.7,26.72,12.7,40.71A29,29,0,0,1,1810.43,2236.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1900.48,2212.31l-24.55-25.48,189.16-168.13c83.07-73.83,121.85-185.07,105-298.69L2107,1294.08c-10.24-69.06-75.52-126.4-146.45-127.83l-4.89-33c89.24,2.11,171.11,74.35,184,161.06l62.94,424.49c9,60.84,3.57,122.41-15.85,178.3A352.77,352.77,0,0,1,2088.74,2044Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1892.6,2228.92a32.61,32.61,0,0,1-26.2-9.89c-11.85-12.25-11.66-30.92.43-41.64l189.5-168.06c80.45-71.34,118-178.94,101.73-288.88-2.32-15.65,8.49-28.77,24.08-29.3s30,11.66,32.3,27.22c9.28,62.64,3.69,126-16.27,183.58a363.63,363.63,0,0,1-100.72,151.34L1909.53,2221.7A29,29,0,0,1,1892.6,2228.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1912.13,1190.62l32.08,1.08c22.85.4,38.61-17.35,35.31-39.65l-1.18-8c-3.31-22.3-24.46-40.87-47.34-41.49l-27.38-1.64c-23.28-.62-73.66,17.22-70.31,39.86l1.2,8.07C1835.56,1183.51,1888.88,1190.21,1912.13,1190.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1854.05,2250.33a175.18,175.18,0,0,1-109.82-27.43l-48.09-30.82c-20.82-13.34-27.2-39.6-14.21-58.55s40.19-23.27,60.81-9.88l47.62,30.94c31.6,20.52,72.39,17.32,97-7.39l37.41-37.5c15.66-15.71,42.26-15.23,59.41,1s18.44,41.92,3,57.65l-36.93,37.55C1924.51,2232.05,1890.28,2247.09,1854.05,2250.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1871.67,2355.6c-23.53,2.38-45.43-14.22-48.82-37.1L1805.43,2201c-3.4-22.88,13.06-43,36.66-44.89s45.16,15,48.53,37.63l17.27,116.49C1911.25,2332.92,1895.08,2353.22,1871.67,2355.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1876,1144.21c2.62,12.81-2.64,24.7-11.75,26.56s-18.62-7-21.24-19.82,2.64-24.69,11.76-26.56S1873.4,1131.4,1876,1144.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1322.78,2561c28.11,151.61-72.46,288.91-227.73,307.05C936.22,2886.58,781,2773.9,751.76,2616s79.4-296,239.41-308.17C1147.61,2295.92,1294.67,2409.38,1322.78,2561Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M1325.27,2564c27.48,150.34-70.84,286.51-222.66,304.49-155.29,18.39-307-93.35-335.64-250s77.63-293.57,234.08-305.61C1154,2301.11,1297.79,2413.63,1325.27,2564Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1301.16,2566.33c25.06,137.09-64.75,261.06-203.11,277.19-141.24,16.46-279-85.28-305-227.57s70.37-266.9,212.57-278.11C1144.91,2326.86,1276.1,2429.25,1301.16,2566.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M1240.5,2572.26c19,103.73-49.28,197.18-153.86,208.88-106.21,11.89-209.35-64.83-228.85-171.51s52.46-200.5,159.22-209.41C1122.13,2391.44,1221.53,2468.52,1240.5,2572.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M1138.16,2582.25c8.68,47.47-22.76,90-70.52,94.93-48.1,5-94.47-29.88-103.25-78s23.41-90.64,71.62-95C1083.89,2499.82,1129.49,2534.78,1138.16,2582.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M1192.23,2773.9c-61.72-70.8-19.42-139.24-78.27-207.57-74.87-86.92-196.64-38-248.4-117.39a110.41,110.41,0,0,1-15.38-37.65C802,2463,778.56,2536.74,793,2616c26,142.29,163.77,244,305,227.57,45.26-5.28,85.32-22.09,117.86-47.13A174.46,174.46,0,0,1,1192.23,2773.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M2361.12,2727.31c8,12.77,6.76,18.75,5.38,21.47-4,8-16.36,2.13-46.26,8.88a51.41,51.41,0,0,1-18.85,1.31c-7.42-.95-16.36-3.92-16.2-5.89.06-.73,1.32-1.14,1.79-1.3,8.22-2.67,59.11-24.3,59.11-24.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M2362.06,2697.3l-1.55,30.58s-12,10.49-16.52-.25c-3.28-7.72-5.46-29.23-5.46-29.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "2211.01 2728.15 2227.32 2761.47 2245.45 2756.61 2237.82 2724.97 2211.01 2728.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M2235.05,2780c7.82-11.52,15.89-11.39,16.74-18.84.66-5.85-3.57-12.5-9.13-14.61-7.82-3-16.21,3.82-18.1,5.35-12.87,10.42-7.64,24.06-20,31.51-2.49,1.49-6.51,3.23-10.45,7.78-1.68,1.94-5.83,6.74-4.44,9.59,1.6,3.31,9.8,2.33,17.59,1.4,9.35-1.11,14-1.66,18.23-5C2231.3,2792.64,2229,2788.85,2235.05,2780Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2385.5,1967.22a999.47,999.47,0,0,1-6.18,181c-6.79,53.67-12.54,63.33-13,100.1-1,80,25.53,89.25,37.66,178.58,13.4,98.64-6.42,179.56-14.28,210.46a569.43,569.43,0,0,1-20.51,64.32c-8.42,8.67-22.56,6.78-37.45,5-12.85-89.41-26.58-173.42-39.42-262.83q-42.91-200.61-85.81-401.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M2331.75,2706.74c-12.85-89.41-26.58-173.42-39.42-262.83q-42.91-200.61-85.81-401.21l179-75.48c.25,4.66.39,9.16.59,13.74-79.84,81.85-91.78,142.43-87.59,182.73,5.08,48.88,33.86,70.93,34.52,142.36.46,51.07-14.06,61.28-10.25,107.09,4.9,59,33,90,48.12,123.1,14.64,32,22.75,78.27,5.23,146.54-2.45,7.1-4.8,13.47-6.92,18.95C2360.78,2710.4,2346.64,2708.51,2331.75,2706.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2282.53,2043.83c-38.78,79.87-58.85,141.86-69.38,180-6.42,23.26-12,47.39-11.18,78.37a241.92,241.92,0,0,0,19.23,87.7,466.56,466.56,0,0,1,30.77,86.76c26.44,107.35,8.51,200.5-7.08,254.51q-15.85,7.4-31.7,14.82a1808.94,1808.94,0,0,1-100.48-281.48c-17.33-65-30.68-116-36.21-181.72-5.84-69.32-5.07-179.8,40.8-315.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2207.59,1445.79c-68.32,17.65-120.05,34.41-140.6,72.66-21.71,40.41,20.25,66,38,149.22,27.14,127.42-42.92,181.66-10.86,309.57a336.18,336.18,0,0,0,40.35,94.9c23.91,16.41,61.57,38.38,111.26,51.27,72.32,18.76,105.8,1.6,200.8-.84,155.39-4,182.26,39,249.85,5.58,68.3-33.73,113.17-113.29,95.53-144.24-10.57-18.53-37.87-4.15-80.41-24.45-54.83-26.17-49.49-68.53-94.89-100.72-65.2-46.24-119.54,10.42-175.36-29.86-56.48-40.75-71.87-150-54.87-217.13,11.11-43.88,7.54-90.3,14.77-135a28.35,28.35,0,0,0-2-16c-10.73-24.44-57.17-25.45-92.25-25.89C2253.43,1434.25,2213.21,1444.34,2207.59,1445.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M2684.2,2080c-22.59-12.5-14.35-53.91-47.84-72.76-31.09-17.49-51.88,10.48-96.36.78-57.06-12.45-58.59-66.26-113.33-78.93-39.36-9.12-48.9,16.31-104.11,22s-129.39-11.16-180.07-65.88a197.9,197.9,0,0,1-42.57-72.92c-10.81,48.91-23,96.35-5.81,165a336.18,336.18,0,0,0,40.35,94.9c23.91,16.41,61.57,38.38,111.26,51.27,72.32,18.76,105.8,1.6,200.8-.84,155.39-4,182.26,39,249.85,5.58,43.65-21.55,77.63-61.8,91.94-96.14C2730.87,2081.53,2700.6,2089.05,2684.2,2080Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M2157.62,1329.16s-16.13,37.44-15.25,62.7,29.12,21.07,29.12,21.07l.25,16a34.49,34.49,0,0,1-20,31.84l-10.87,5s74.42,9.6,112-21.93l-11.6-.17a34.51,34.51,0,0,1-33.42-28.18l-1.26-6.73S2212.84,1329.29,2157.62,1329.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M2083.05,1737.82l-111.27-191.94a6.22,6.22,0,0,0-6.8-2.94l-155.68,36.38a6.22,6.22,0,0,0-3.86,9.36l129.12,206.46a6.22,6.22,0,0,0,7.39,2.56l136.82-49.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M2055.68,1716l-90.1-155.41a5,5,0,0,0-5.51-2.38l-126,29.46a5,5,0,0,0-3.12,7.58l104.54,167.17a5.06,5.06,0,0,0,6,2.07l110.78-40Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M1939,1562.41l-7.15-12.47a4.55,4.55,0,0,0-4.95-2.17l-64.84,14.58a4.56,4.56,0,0,0-2.93,6.75l8,13.55a4.54,4.54,0,0,0,5,2.12l64-15.67A4.55,4.55,0,0,0,1939,1562.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M1854.07,1615.85l.3-.06,114.14-26.94a2.62,2.62,0,0,0,2-3.15,2.67,2.67,0,0,0-3.16-2l-114.15,26.94a2.63,2.63,0,0,0,.91,5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M1861.22,1626.91l.33-.06,113.45-28a2.63,2.63,0,1,0-1.26-5.1l-113.45,28a2.63,2.63,0,0,0,.93,5.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M1921.07,1639.22a2.66,2.66,0,0,0,.39-.07l61.68-17a2.63,2.63,0,1,0-1.39-5.07l-61.68,17a2.63,2.63,0,0,0,1,5.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M1903,1744.62s-27.54-14.8-31.83-26.82-6-35.28-6-35.28l18.4,31.11s7-2.84,9-13.93,8.3-1.78,7,6.58S1903,1744.62,1903,1744.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2078,1505a192.63,192.63,0,0,0-47.31,51.67c-44.52,72-17,140.94-57,170.5-11.43,8.46-32.2,16.53-72.23,6.91l-14,9.41s-8.46,93.8,103.5,85.57,153.07-152.78,153.07-152.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2113.43,1626c-21.74-.12-37.52,75.11-40.37,89.16-11.64,48.61-27.29,62.5-40.18,65.43-19.55,4.45-29.48-17-60.85-14.92-21.8,1.47-29.51,12.7-51.66,10.33-13.74-1.47-24.53-7.27-31.58-12,1.85,10.3,6.48,27.79,20.66,42.09,15,15.08,39.93,26.12,81.56,23.06,112-8.22,153.07-152.78,153.07-152.78C2130,1628.81,2117.59,1626,2113.43,1626Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2172,1363.87c3.75-.63,6.48-5.68,9.19-4.47s3.11,8.28,1.16,13.38a17.76,17.76,0,0,1-6.24,7.92,46.66,46.66,0,0,1,9.72,17.86c4.93,17.89-3.52,33.31-6.83,42.19-14.91,40.06,18.31,98.69,51.79,126.91,27.2,22.95,38.1,11.91,54.79,31.11,32.51,37.36-4.18,84.42,15.36,136.71,29.72,79.51,160.28,93.07,165.68,93.57,2.13.2,3.56.31,5.78.48,58.43,4.38,147,11,204.62-41.41,43.12-39.23,59.13-102.62,51.14-156.62-2.1-14.2-10.92-68-58.76-108.63-7.59-6.44-52.54-44.49-108.68-40.34-29.74,2.19-34.86,13.16-58.12,8.57-31.85-6.28-53.35-33-66.7-49.54-24.54-30.46-16.22-38.09-33.27-52.65-33.4-28.55-67.54-1.13-102.74-25.84-34.7-24.36-18.16-62.69-51.43-83.5-34.32-21.47-95.44-7.92-106.24,21.93C2133,1327.15,2160.49,1365.79,2172,1363.87Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErpImg2);
export default __webpack_public_path__ + "static/media/erp_img_2.dcaa24bc6f7f41b51ce5ddd41b500436.svg";
export { ForwardRef as ReactComponent };